import { render, staticRenderFns } from "./reminders.vue?vue&type=template&id=37c817ef"
import script from "./reminders.vue?vue&type=script&lang=js"
export * from "./reminders.vue?vue&type=script&lang=js"
import style0 from "./reminders.vue?vue&type=style&index=0&id=37c817ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports